export default "__VITE_ASSET__D16PD4H4__"